import Vue from 'vue';
import VueI18n from 'vue-i18n';
import el from './locales/el.json';
import en from './locales/en.json';

Vue.use(VueI18n);

const getUsersPreferredLanguageOrDefaultToEnglish = () => {
  return navigator.language.includes('el') ? 'el' : 'en';
};

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || getUsersPreferredLanguageOrDefaultToEnglish(),
  fallbackLocale: 'en',
  messages: {
    el,
    en,
  },
  silentFallbackWarn: true,
});

export default i18n;
